module.exports = __webpack_public_path__ + "img/csr_032423_F.833e40ac.jpg";